import { NavLink } from 'react-router-dom';
import { OnlineBadge } from './OnlineBadge.js';

export function TopBar({ online, operationName }: { online: boolean; operationName: string }) {
  return (
    <header className="top-bar top-bar--player">
      <div className="top-bar__title mono">
        <span className="top-bar__dot" aria-hidden="true" />
        {operationName}
      </div>
      <nav className="top-bar__nav mono" aria-label="ניווט ראשי">
        <NavLink to="/" end className={({ isActive }) => (isActive ? 'top-bar__link is-active' : 'top-bar__link')}>
          מסוף
        </NavLink>
        <NavLink to="/history" className={({ isActive }) => (isActive ? 'top-bar__link is-active' : 'top-bar__link')}>
          היסטוריה
        </NavLink>
        <NavLink to="/decoder" className={({ isActive }) => (isActive ? 'top-bar__link is-active' : 'top-bar__link')}>
          פענוח צופן
        </NavLink>
      </nav>
      <div className="top-bar__status">
        <OnlineBadge online={online} />
      </div>
    </header>
  );
}
